(function () {
  function init(section) {
    if (!section || section.dataset.barefootFaqReady === 'true') return;
    section.dataset.barefootFaqReady = 'true';
    var button = section.querySelector('[data-back-to-top]');
    if (!button) return;
    button.addEventListener('click', function () {
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-barefoot-faq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
